export default __webpack_public_path__ + "static/media/2003302FA716-QRCODESGQR_20200330.ae6a5e81.png";